var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482.284 342.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "maskPath",
    d: "M2389.125,8793.5c14.261,63.308,18.64,127.877,42.671,62.635s54.012-167.877,78.717-202.238,21.672-87.477,91.293-65.8,109.26,54.688,150.471,34.475,56.932-104.207,101.063-65.242-50.98,190.11,12.689,215.6",
    transform: "translate(-2386.198 -8544.199)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maskReveal",
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M2389.125,8793.5c14.261,63.308,18.64,127.877,42.671,62.635s54.012-167.877,78.717-202.238,21.672-87.477,91.293-65.8,109.26,54.688,150.471,34.475,56.932-104.207,101.063-65.242-50.98,190.11,12.689,215.6",
    transform: "translate(-2386.198 -8544.199)",
    fill: "none",
    stroke: "#ff4b4b",
    strokeWidth: 6,
    strokeDasharray: "8 5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath3);
export default __webpack_public_path__ + "static/media/path-3.38afbe56.svg";
export { ForwardRef as ReactComponent };